module.exports = __webpack_public_path__ + "media/bootstrap-icons/arrow-down-square-fill-f910dd8e.svg";